import { handleApiError } from '@errors/api-error-handler';
import { isHttpError } from '@utils/common.utils';

export async function fetchWithLogs(
  input: RequestInfo | URL,
  init?: RequestInit,
  label?: string,
): Promise<Response> {
  const request = new Request(input, init);

  try {
    const response = await fetch(request);

    if (response.type === 'opaqueredirect') {
      return response;
    }

    if (!response.ok) {
      const body = (await readResponseBody(response)) as {
        message?: string;
        error?: string;
      };
      const detail =
        body?.message ?? body?.error ?? response.statusText ?? response.status;

      handleApiError(
        request.method,
        request.url,
        label ? `${label}: ${detail}` : String(detail),
      );
    }

    return response;
  } catch (error) {
    // prevent double logging
    if (isHttpError(error)) {
      throw error;
    }

    const detail =
      error instanceof Error ? error.message : 'Network request failed';

    handleApiError(
      request.method,
      request.url,
      label ? `${label}: ${detail}` : detail,
    );
  }
}

async function readResponseBody(response: Response): Promise<unknown> {
  const cloned = response.clone();

  try {
    return await cloned.json();
  } catch {
    try {
      return await cloned.text();
    } catch {
      return null;
    }
  }
}
